import http from '@/fetch';

const debounce = async (context,key)=>{
  // 防抖
  return new Promise(resolve=>{
    const preTime = context.state.globalDebounceObj[key];
    const nowTime = new Date().getTime();
    if (preTime && preTime - nowTime < 200){
      // 如果同一个请求间隔相差200 毫秒
      // 则延迟300毫秒执行获取字典，防止同一个接口多次执行
      setTimeout(()=>{resolve();},300);
    } else {
      resolve();
    }
    context.state.globalDebounceObj[key] = new Date().getTime();
  });
  
};

const store = {
  state: {
    globalDebounceObj: {
     
    },// 优化同一个接口，同时并发多次请求
    activationStatus: [],// 激活码状态
    couponStatus: [],// 优惠券状态,
    orderSource: [], // 系统列表
    subject: [],// 开票/收款主体
    productStatus: [], // 产品/版本状态
    switchStatus: [], // 启停
    // classifyList: [], // 应用分类分页查询
    property: [], // 通过规格属性
    orderStatus: [],// 订单状态
    buyRecordStatus: [],// 服务状态
    checkStatus: [], // 审核状态
    productList: [], // 查询系统下所有可用的商品
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    // 激活码状态
    async getActivationStatus(context) {
      // 防抖
      const key = 'activationStatus';
      await debounce(context,key);

      let list = context.state[key];
      if (!list || !list.length) {
        const res = await http.get('/paycenter-charge/api/common/activation/status');
        if (res && res.success) {
          list = res.data.map(ele => {
            return {
              label: ele.value,
              value: ele.key,
            };
          });
        }
      }
      context.state[key] = list;
      return list;
    },
    // 优惠券状态
    async getCouponStatus(context) {
      const key = 'couponStatus';
      await debounce(context,key);
      
      let list = context.state[key];
      if (!list || !list.length) {
        const res = await http.get('/paycenter-charge/api/common/coupon/status');
        if (res && res.success) {
          list = res.data.map(ele => {
            return {
              label: ele.value,
              value: ele.key,
            };
          });
        }
      }
      context.state[key] = list;
      return list;
    },
    // 系统列表
    async getOrderSource(context) {
      // 防抖
      const key = 'orderSource';
      await debounce(context,key);

      let list = context.state[key];
      if (!list || !list.length) {
        const res = await http.get('/paycenter-charge/api/common/order/source');
        if (res && res.success) {
          list = res.data.map(ele => {
            return {
              label: ele.value,
              value: ele.key,
            };
          });
        }
      }
      context.state[key] = list;
      return list;
    },
    // 开票/收款主体
    async getSubject(context) {
      // 防抖
      const key = 'subject';
      await debounce(context,key);
  
      let list = context.state[key];
      if (!list || !list.length) {
        const res = await http.get('/paycenter-charge/api/common/pay/subject');
        if (res && res.success) {
          list = res.data.map(ele => {
            return {
              label: ele.value,
              value: ele.key,
            };
          });
        }
      }
      context.state[key] = list;
      return list;
    },
    // 产品/版本状态
    async getProductStatus(context) {
      // 防抖
      const key = 'productStatus';
      await debounce(context,key);

      let list = context.state[key];
      if (!list || !list.length) {
        const res = await http.get('/paycenter-charge/api/common/product/status');
        if (res && res.success) {
          list = res.data.map(ele => {
            return {
              label: ele.value,
              value: ele.key,
            };
          });
        }
      }
      context.state[key] = list;
      return list;
    },
    // 启停
    async getSwitchStatus(context) {
      // 防抖
      const key = 'switchStatus';
      await debounce(context,key);
  
      let list = context.state[key];
      if (!list || !list.length) {
        const res = await http.get('/paycenter-charge/api/common/switch/status');
        if (res && res.success) {
          list = res.data.map(ele => {
            return {
              label: ele.value,
              value: ele.key,
            };
          });
        }
      }
      context.state[key] = list;
      return list;
    },
    // 通过规格属性
    async getProperty(context) {
      // 防抖
      const key = 'property';
      await debounce(context,key);
  
      let list = context.state[key];
      if (!list || !list.length) {
        const res = await http.get('/paycenter-charge/api/common/product/property');
        if (res && res.success) {
          list = res.data.map(ele => {
            return {
              label: ele.value,
              value: ele.key,
            };
          });
        }
      }
      context.state[key] = list;
      return list;
    },
    // 订单状态
    async getOrderStatus(context) {
      // 防抖
      const key = 'orderStatus';
      await debounce(context,key);
  
      let list = context.state[key];
      if (!list || !list.length) {
        const res = await http.get('/paycenter-charge/api/common/order/status');
        if (res && res.success) {
          list = res.data.map(ele => {
            return {
              label: ele.value,
              value: ele.key,
            };
          });
        }
      }
      context.state[key] = list;
      return list;
    },
    // 服务状态
    async getBuyRecordtatus(context) {
      // 防抖
      const key = 'buyRecordStatus';
      await debounce(context,key);
    
      let list = context.state[key];
      if (!list || !list.length) {
        const res = await http.get('/paycenter-charge/api/common/buyRecord/status');
        if (res && res.success) {
          list = res.data.map(ele => {
            return {
              label: ele.value,
              value: ele.key,
            };
          });
        }
      }
      context.state[key] = list;
      return list;
    },
    // 审核状态
    async getCheckStatus(context) {
      // 防抖
      const key = 'checkStatus';
      await debounce(context,key);
    
      let list = context.state[key];
      if (!list || !list.length) {
        const res = await http.get('/paycenter-charge/api/common/check/status');
        if (res && res.success) {
          list = res.data.map(ele => {
            return {
              label: ele.value,
              value: ele.key,
            };
          });
        }
      }
      context.state[key] = list;
      return list;
    },
    // 查询系统下所有可用的商品
    async getProductList(context) {
      // 防抖
      const key = 'productList';
      await debounce(context,key);
  
      let list = context.state[key];
      if (!list || !list.length) {
        const res = await http.get('/paycenter-charge/api/product/info/listAllEnable');
        if (res && res.success) {
          list = res.data.map(ele => {
            return {
              label: ele.value,
              value: ele.key,
            };
          });
        }
      }
      context.state[key] = list;
      return list;
    },
  },
};

export default store;
